import { createSlice } from "@reduxjs/toolkit";
import {
  districtData,
  divisionData,
  GetGeoInitialStatus,
  policeStationData,
} from "../../../../types/geo/geo";
import { capitalize } from "../../../../utils/string";
import {
  getAllDistrictAsync,
  getAllDivisionAsync,
  getAllPoliceStationAsync,
} from "./getGeoApi";

const initialState: GetGeoInitialStatus<
  divisionData,
  districtData,
  policeStationData
> = {
  loading: false,
  manageLoading: false,

  divisionList: [],
  districtList: [],
  policeStationList: [],

  countDivision: 0,
  countDistrict: 0,
  countPoliceStation: 0,
};

const getGeoSlice = createSlice({
  name: "admin-getGeo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all division
    builder
      .addCase(getAllDivisionAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllDivisionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.divisionList = (action.payload.data || []).map((item) => ({
          ...item,
          divisionName: capitalize(item.divisionName),
        }));
        state.countDivision = action.payload.length;
      })
      .addCase(getAllDivisionAsync.rejected, (state) => {
        state.loading = false;
        state.divisionList = [];
        state.countDivision = 0;
      });

    // get all district
    builder
      .addCase(getAllDistrictAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllDistrictAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.districtList = (action.payload.data || []).map((item) => ({
          ...item,
          districtName: capitalize(item.districtName),
          division_id:
            typeof item.division_id === "object" && item.division_id !== null
              ? {
                  ...item.division_id,
                  divisionName: capitalize((item.division_id as any).divisionName),
                }
              : item.division_id,
        }));
        state.countDistrict = action.payload.length;
      })
      .addCase(getAllDistrictAsync.rejected, (state) => {
        state.loading = false;
        state.districtList = [];
        state.countDistrict = 0;
      });

    // get all police station
    builder
      .addCase(getAllPoliceStationAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllPoliceStationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.policeStationList = action.payload.data;
        state.countPoliceStation = action.payload.length;
      })
      .addCase(getAllPoliceStationAsync.rejected, (state) => {
        state.loading = false;
        state.policeStationList = [];
        state.countPoliceStation = 0;
      });
  },
});

export default getGeoSlice;
